// Display constants for the KYC Change Requests module.

export const KYCStatus = {
  ComplianceReview: "COMPLIANCE REVIEW",
  ComplianceReviewCEO: "COMPLIANCE REVIEW - CEO",
  AdvisorReview: "ADVISOR REVIEW",
  EscalatedToCEO: "ESCALATED TO CEO",
  Closed: "CLOSED",
  Rejected: "REJECTED",
};

export const KYCPersonType = {
  Physical: "Physical",
  Juridical: "Juridical",
};

export const KYCRiskLevel = {
  Low: "Low",
  Medium: "Medium",
  High: "High",
};
